<script setup lang="ts">
import { computed } from 'vue'

const emit = defineEmits<{
  (e: 'restore'): void
  (e: 'discard'): void
}>()

const actions = computed(() => [
  {
    label: 'Entwurf wiederherstellen',
    color: 'primary' as const,
    size: 'xs' as const,
    onClick: () => emit('restore')
  },
  {
    label: 'Verwerfen',
    color: 'neutral' as const,
    variant: 'ghost' as const,
    size: 'xs' as const,
    onClick: () => emit('discard')
  }
])
</script>

<template>
  <UAlert
    color="info"
    variant="subtle"
    icon="i-lucide-file-text"
    title="Gespeicherter Entwurf vorhanden"
    description="Möchten Sie Ihren zuvor gespeicherten Entwurf wiederherstellen?"
    :actions="actions"
  />
</template>
